import React from 'react';
import classNames from 'classnames/bind';
import styles from './Privacy.module.scss';

const cx = classNames.bind(styles);

function Privacy_03() {
	return (
		<div className={cx('terms')}>
			<p>매도자는 매매계약 체결과 관련하여 아래와 같은 개인의 정보를 수집 및 이용하고자 하오니 동의하여 주시기 바랍니다.</p>
			<dl className={cx('dl_type1')}>
				<dt>수집항목(*필수)</dt>
				<dd>
					신청자 :<br />
					*이름, *휴대전화번호, *이메일, *배송지주소, *우편수령지주소, *생년월일
					<br />
					<br />
					명의자 :<br />
					명의자 이름, 명의자 휴대전화번호, 공동 명의자 등본 주소, 명의자 배송지 주소, 명의자 등기 주소, 명의자 이메일, *명의자 주민등록번호
					<br />
					공동 명의자 이름, 공동 명의자 휴대전화번호, 공동 명의자 등본 주소, 공동 명의자 주민등록번호
				</dd>
				<dt>수집항목(선택)</dt>
				<dd>신청자 : 환불계좌(은행명, 예금주, 계좌번호)</dd>
				<dt>이용목적</dt>
				<dd>
					매매계약상 의무이행목적(대금청구처 송부, 대금결제, 탁송, 등록대행 등), 본인확인 목적, 분쟁 조정을 위한 기록 보관, 불만처리 등
					민원처리, 고지사항 전달, 고객관리(서비스만족도 조사, 차량관리 안내 등)
				</dd>
				<dt>이용/보관기간</dt>
				<dd>
					<span className={cx('important')}>5년</span>
					<br />
					단, 관계 법령에 따라 개인 정보를 보존해야 하는 경우 관계 법령에서 정하는 기간까지 보존
				</dd>
			</dl>
			<p className={cx('pt20')}>
				*위의 개인 정보 수집, 이용에 대한 동의를 거부할 권리가 있습니다. 단, 동의를 거부하실 경우 엔카 홈서비스 이용이 제한됩니다.
			</p>
			<dl className={cx('dl_type2')}>
				<dt>■ 제공 및 변경에 관한 세부 사항</dt>
				<dd>
					엔카닷컴은 위 제휴 업체에게 개인정보를 제공할 경우, 상기한 목적 범위 내에서 제공하며, 위 제공대상 업체 현황, 제공 대상 개인정보
					이용목적, 제공대상 개인정보 항목의 세부적인 내용은 엔카닷컴 홈페이지 (www.encar.com)에서 확인하실 수 있습니다. 엔카닷컴은 위탁하는
					업무의 내용 및 수탁업체 현황의 세부적인 내용은 상기 엔카닷컴 홈페이지에서 확인하실 수 있습니다. 위 사항의 변경이 있을 경우에는 위
					홈페이지에 변경 내용을 게시합니다.
				</dd>
			</dl>
		</div>
	);
}

export default Privacy_03;
